<script lang="ts" setup>
defineProps<{
  name: 'fade' | 'scale' | 'slide-x-fade' | 'slide-y-fade' | 'flip-x' | 'expand' | 'slide-y' | 'slide-x';
  mode?: 'out-in' | 'in-out';
}>();

const emit = defineEmits<{
  (event: 'onEnter'): void;
  (event: 'onLeave'): void;
}>();
</script>

<template>
  <Transition :name="name" :mode="mode || 'out-in'" @enter="emit('onEnter')" @leave="emit('onLeave')">
    <slot />
  </Transition>
</template>
